import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.css']
})
export class AddCompanyComponent implements OnInit {
  respPeer: any;
  respcreate: any;
  peerData: any;
  errCounter = 0;
  companyName ='';
  companyID='';
  companyLogo='';
  emailAddress='';
  peerGroup='1';
  industryType='General';
  industryTypeData=[];
  loaderVisibility: boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

  ngOnInit(){
    this.industryTypeData=['General','Standalone Health','Specialized','Indian Business','Foreign Business'];
  	this.loaderVisibility=false;
  	const peerData = {}
  	this._rest.getPeerGroup(peerData).subscribe((res) => {
  		this.respPeer	=	res;
  		this.peerData	=	this.respPeer.details;
  		//console.log(JSON.stringify(this.respPeer.details));
  		
  	})
  }
  resetForm(){
  	this.companyName='';
  	this.companyID='';
  	this.companyLogo='';
  	this.emailAddress='';
  	this.peerGroup='1';
    this.industryType='General';
    this.industryTypeData=['General','Standalone Health','Specialized','Indian Business','Foreign Business'];
  }
  createCompany(){
  	this.loaderVisibility=true;
    this.errCounter=0;
  	const companyLogo1 = <HTMLInputElement>document.getElementById('companyLogo');
  	//document.getElementById('loaderbox').style.display = "";
  	if(this.companyName==""){
  		this.errCounter++;
  	}
  	if(this.companyID==""){
  		this.errCounter++;
  	}
    console.log(this.companyLogo);
  	if(this.companyLogo==""){
  		this.errCounter++;
  	}
  	if(this.emailAddress==""){
  		this.errCounter++;
  	}
  	if(this.errCounter==0){
  		const fd = new FormData();
		fd.append('logo', companyLogo1.files[0]);
		fd.append('companyName', this.companyName);
		fd.append('companyCode', this.companyID);
		fd.append('companyEmail', this.emailAddress);
		fd.append('peerId',this.peerGroup);
    fd.append('industryType',this.industryType);
  		this._rest.addCompany(fd).subscribe((res) => {
  			this.loaderVisibility=false;
  			this.respcreate = res;
  			//console.log(JSON.stringify(res));
  			if(this.respcreate.resp.companyId!==undefined){
  				alert(this.companyName+" has been added successfully.");
          this.resetForm();
  			} else {
  				alert(this.respcreate.resp.message);
  			}  			
  		});
  	} else {
  		alert("All fields are required");
      this.loaderVisibility=false;
  	}
  }

}
